import TomSelect from 'tom-select/dist/js/tom-select.base.js'

interface LocationOption {
  id: string
  address: string
}

interface JobLocationSelectData {
  location_id: string
  up_target: string
  job_id: string
  options: LocationOption[]
}

up.compiler(
  '[data-job-location-select]',
  (
    element: HTMLSelectElement,
    { location_id: locationId, up_target: upTarget, job_id: jobID, options }: JobLocationSelectData,
  ) => {
    const section = element.closest<HTMLElement>('.career-card--location-section')!
    const toggleElement = section.querySelector<HTMLElement>('[job-location-toggle]')!

    function toggle(open: boolean): void {
      section.classList.toggle('-open', open)
      if (open) {
        tomselect.open()
      }
    }

    const tomselect = new TomSelect(element, {
      options: options.map(({ id, address }) => ({ value: id, text: address })),
      items: [locationId],
      create: false,
      closeAfterSelect: true,
      hidePlaceholder: false,
      maxOptions: null,
      onChange(locationValue: string) {
        const newUrlWithUpdatedLocationAndJob = currentUrlWithDifferentQueryParameter({
          l: locationValue,
          j: jobID,
        })
        up.visit(newUrlWithUpdatedLocationAndJob, { target: upTarget })
      },
      onBlur() {
        toggle(false)
      },
      render: {
        no_results({ input }: { input: string }) {
          return '<div class="no-results">Keine Ergebnisse.</div>'
        },
      },
    })

    toggleElement.addEventListener('click', (event: MouseEvent) => {
      event.preventDefault()
      toggle(true)
    })

    return () => {
      tomselect.destroy()
    }
  },
)

function currentUrlWithDifferentQueryParameter(overrides: Record<string, string>): string {
  const currentUrl = new URL(window.location.href)
  Object.entries(overrides).forEach(([key, value]) => {
    if (key && value) {
      currentUrl.searchParams.set(key, value)
    }
  })
  return currentUrl.toString()
}
